import React, { useContext, useState } from "react";
import DateTime from "../../Components/DateTime";
import dayjs from "dayjs";
import {
  Button,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  TableSortLabel,
  LinearProgress,
} from "@mui/material";
import { UserContext } from "../../Layout";
import { Search } from "@mui/icons-material";
import { APIServices } from "../../helpers/APIServices";
import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { parseStatus, parseFullNameFromUser } from "../../helpers/common";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeletePaperModal from "../../Components/DeletePaperModal";
import SimpleBackdrop from "../../Components/Backdrop";
import _ from "lodash";
import FileDownload from "@mui/icons-material/FileDownload";
import { export_exceljs } from "../../Components/ExportInspectionSheet";
import { export_cpk } from "../../Components/ExportCPK";
import { export_cpk2 } from "../../Components/ExportCPK_form2";
import { export_cpu } from "../../Components/ExportCPU";
import { export_cpl } from "../../Components/ExportCPL";
import { exportData } from "../../helpers/common";
import { exportDataALL } from "../../helpers/common";

const getStartDateFilter = (partId) => {
  if (!partId) return undefined;
  const value = localStorage.getItem(`filterQCASP_${partId}`);
  return value ? JSON.parse(value)?.startDate : undefined;
};
const setStartDateFilter = (partId, startDate) => {
  if (!partId) return;
  const oldValue = localStorage.getItem(`filterQCASP_${partId}`) || "{}";
  const newValue = {
    ...JSON.parse(oldValue),
    startDate,
  };
  localStorage.setItem(`filterQCASP_${partId}`, JSON.stringify(newValue));
};

const getEndDateFilter = (partId) => {
  if (!partId) return undefined;
  const value = localStorage.getItem(`filterQCASP_${partId}`);
  return value ? JSON.parse(value)?.endDate : undefined;
};
const setEndDateFilter = (partId, endDate) => {
  if (!partId) return;
  const oldValue = localStorage.getItem(`filterQCASP_${partId}`) || "{}";
  const newValue = {
    ...JSON.parse(oldValue),
    endDate: endDate,
  };
  localStorage.setItem(`filterQCASP_${partId}`, JSON.stringify(newValue));
};

const CustomDateHistory = ({ partData, setSuccess }) => {
  const { id } = useParams();
  const [startDate, setStartDate] = useState({
    value: getStartDateFilter(id)
      ? getStartDateFilter(id)
      : `${dayjs().subtract(1, "d").format("YYYY-MM-DD")} 00:00:00`,
    error: false,
  });
  const [endDate, setEndDate] = useState({
    value: getEndDateFilter(id)
      ? getEndDateFilter(id)
      : `${dayjs().format("YYYY-MM-DD")} 23:59:59`,
    error: false,
  });
  const [papers, setPapers] = useState([]);
  const [partsId, setPartIds] = useState(id);
  const [loading, setLoading] = useState(true);

  const user = useContext(UserContext);
  const role = user.qc_role;
  const [openDelete, setOpenDelete] = useState({
    open: false,
    message: "",
  });
  const [data, setData] = useState();
  const [apiSuccess, setapiSuccess] = useState(true);
  const [checkedPaperId, setCheckedPaperId] = useState({});
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("status");

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleOnChangeStartDate = (date, time) => {
    if (!date || !time) {
      setStartDate((prev) => ({
        ...prev,
        value: undefined,
      }));
      return;
    }
    const startDate = dayjs(`${date} ${time}`).format("YYYY-MM-DD HH:mm:ss");
    setStartDate((prev) => ({
      ...prev,
      value: startDate,
      error: false,
    }));
    setStartDateFilter(id, startDate);
  };

  const handleOnChangeEndDate = (date, time) => {
    if (!date || !time) {
      setEndDate((prev) => ({
        ...prev,
        value: undefined,
      }));
      return;
    }
    const endDate = dayjs(`${date} ${time}`).format("YYYY-MM-DD HH:mm:ss");
    setEndDate((prev) => ({
      ...prev,
      value: endDate,
      error: false,
    }));
    setEndDateFilter(id, endDate);
  };
  const getPaper = async () => {
    setLoading(true);
    try {
      const startDateParsed = dayjs(startDate.value).toISOString();
      const endDateParsed = dayjs(endDate.value).toISOString();
      const response = await APIServices.getPaperHistory(
        startDateParsed,
        endDateParsed,
        id,
        user,
      );

      const papersData = response.data?.data;

      if (Array.isArray(papersData)) {
        setPapers(papersData);
        if (id) {
          setPartIds(id);
        }
      } else {
        setPapers([]);
      }
    } catch (error) {
      console.error("Error fetching papers:", error);
      setPapers([]);
    } finally {
      setLoading(false);
    }
  };

  const submitSearch = async () => {
    getPaper();
  };

  const deletePaper = async (result, row) => {
    // console.log("result",result, row);
    // return;

    if (result) {
      setLoading(true);
      await APIServices.updateDeletePaper(true, row.id);
      // partData.mutate();
      setTimeout(() => {
        setLoading(false);
        // setSuccess(true);
        setapiSuccess(true);
      }, 1000);
    }
  };

  const handleOnClickDelete = (row) => {
    setData(row);
    let message = "ลบข้อมูลใช่หรือไม่";
    setOpenDelete({ open: true, message: message });
  };

  const Action = ({ row, index }) => {
    if (role === "super_admin") {
      return (
        <>
          <Link
            key={"view_paper_v2"}
            to={`view_paper_v2/${row.id}`}
            state={{ index: index + 1 }}
          >
            <IconButton color="primary">
              <VisibilityIcon />
            </IconButton>
          </Link>
          <Link
            key={"edit_paper_v3"}
            to={`edit_paper_v3/${row.id}`}
            state={{ index: index + 1 }}
          >
            <IconButton color="primary">
              <EditIcon />
            </IconButton>
          </Link>
          <IconButton color="error" onClick={() => handleOnClickDelete(row)}>
            <DeleteIcon />
          </IconButton>
        </>
      );
    }
    if (role === "inspector") {
      // if (row.attributes.status === "1") {
      return (
        <>
          <Link
            key={"edit_paper_v3"}
            to={`edit_paper_v3/${row.id}`}
            state={{ index: index + 1 }}
          >
            <IconButton color="primary">
              <EditIcon />
            </IconButton>
          </Link>
          <IconButton color="error" onClick={() => handleOnClickDelete(row)}>
            <DeleteIcon />
          </IconButton>
        </>
      );
      // }
    } else if (
      role === "checker" ||
      role === "approver" ||
      // role === "super_admin" ||
      role === "admin"
    ) {
      return (
        <>
          <Link
            key={"view_paper_v2"}
            to={`view_paper_v2/${row.id}`}
            state={{ index: index + 1 }}
          >
            <IconButton color="primary">
              <VisibilityIcon />
            </IconButton>
          </Link>
        </>
      );
    } else {
      return <div>Action</div>;
    }
  };

  useEffect(() => {
    if (id) {
      setPartIds(id);
      const savedStart = getStartDateFilter(id);
      const savedEnd = getEndDateFilter(id);
      setStartDate({
        value:
          savedStart ||
          `${dayjs().subtract(1, "d").format("YYYY-MM-DD")} 00:00:00`,
        error: false,
      });
      setEndDate({
        value: savedEnd || `${dayjs().format("YYYY-MM-DD")} 23:59:59`,
        error: false,
      });
      setapiSuccess(true);
    }
  }, [id]);

  useEffect(() => {
    if (apiSuccess) {
      setapiSuccess(false);
      getPaper();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiSuccess]);

  useEffect(() => {
    // papers.map((e) => {
    // const partId = e.attributes.answer.partId;
    console.log(partsId);
    // });
  }, [partsId]);

  const handleCheckedPaper = (checked, paperId) => {
    if (checked) {
      setCheckedPaperId((prev) => ({ ...prev, [paperId]: true }));
    } else {
      setCheckedPaperId((prev) => {
        const next = { ...prev };
        delete next[paperId];
        return next;
      });
    }
  };

  const sortedPapers = React.useMemo(() => {
    if (!papers) return [];

    const comparator = (a, b) => {
      let valueA, valueB;

      if (orderBy === "id") {
        valueA = Number(a.id);
        valueB = Number(b.id);
      } else if (orderBy === "create_datetime") {
        valueA = new Date(a.attributes.create_datetime).getTime();
        valueB = new Date(b.attributes.create_datetime).getTime();
      } else if (orderBy === "status") {
        const statusPriority = {
          1: 1, // รอการดำเนินการตรวจสอบ
          2: 2, // ผ่านการตรวจสอบ
          4: 3, // ผ่านการอนุมัติ
        };
        valueA = statusPriority[a.attributes.status] || 4;
        valueB = statusPriority[b.attributes.status] || 4;
      } else if (orderBy === "machineNumber") {
        valueA = (a.attributes?.machineNumber || "").toLowerCase();
        valueB = (b.attributes?.machineNumber || "").toLowerCase();
      } else {
        valueA = a.attributes[orderBy];
        valueB = b.attributes[orderBy];
      }

      if (valueA < valueB) {
        return order === "asc" ? -1 : 1;
      }
      if (valueA > valueB) {
        return order === "asc" ? 1 : -1;
      }
      return 0;
    };

    return [...papers].sort(comparator);
  }, [papers, order, orderBy]);

  const clearAllCheckedPaperId = (e, checked) => {
    if (checked) {
      let paperId = {};
      papers.forEach((paper) => {
        paperId[`${paper.id}`] = true;
      });
      setCheckedPaperId(paperId);
    } else {
      setCheckedPaperId({});
    }
  };

  function updateCplData(prevCplData, results) {
    const updatedFirstEntry = {
      ...prevCplData[0],
      answer: {
        ...prevCplData[0].answer,
        sub_categories: prevCplData[0].answer.sub_categories.map(
          (subCat, subIndex) => ({
            ...subCat,
            questions: subCat.questions.map((question, qIndex) => {
              const newActuals = results
                .slice(1)
                .map(
                  (result) =>
                    result.answer.sub_categories[subIndex]?.questions[qIndex]
                      ?.actual || [],
                )
                .flat();
              return {
                ...question,
                actual: [...question.actual, ...newActuals],
              };
            }),
          }),
        ),
      },
    };

    return [updatedFirstEntry, ...prevCplData.slice(1)];
  }

  const downloadCpk = async (formatTorelance) => {
    setLoading(true);
    try {
      // let formatTorelance = "";
      let allTorelance = [];
      let allTorelance2 = [];
      let allSpecCount = [];
      const checkedArray = Object.keys(checkedPaperId).map((key) => key);
      if (checkedArray.length === 0) {
        return;
      }
      if (partsId) {
        const getSpec = await APIServices.getPartByID(partsId);
        const allSpec =
          getSpec.data.data.attributes.sub_categories.data[0].attributes
            .questions;
        Array.isArray(
          allSpec.data.map((e) => allTorelance.push(e.attributes.torelance1)),
        );
        Array.isArray(
          allSpec.data.map((e) => allTorelance2.push(e.attributes.torelance2)),
        );
        Array.isArray(
          allSpec.data.map((e) => allSpecCount.push(e.attributes.specCount)),
        );
        allSpec.data.map(
          (e) => (formatTorelance = e.attributes.formatTorelance),
        );
      }
      console.log(`Check Spec-Count : ${allSpecCount}`);
      console.log(`Check torelance1 : ${allTorelance}`);
      console.log(`Check torelance2 : ${allTorelance2}`);
      console.log(`Check formatTorelance : ${formatTorelance}`);

      const response = await APIServices.getManyPaper(checkedArray);
      const result = response.data.data;
      let updatedData = updateCplData(result, result);
      console.log(updatedData);
      const dataForExport = exportDataALL(updatedData);
      console.log(dataForExport);
      await export_cpk(
        dataForExport,
        allTorelance,
        allTorelance2,
        formatTorelance,
        allSpecCount,
      );
      // cplData = [];
    } catch (e) {
      console.error("Error in DownloadCPK:", e);
    }
    setLoading(false);
  };
  const downloadCpk_2 = async (formatTorelance) => {
    setLoading(true);
    try {
      // let formatTorelance = "";
      let allTorelance = [];
      let allTorelance2 = [];
      let allSpecCount = [];
      const checkedArray = Object.keys(checkedPaperId).map((key) => key);
      if (checkedArray.length === 0) {
        return;
      }
      if (partsId) {
        const getSpec = await APIServices.getPartByID(partsId);
        // const allSpec =
        //   getSpec.data.data.attributes.sub_categories.data[0].attributes
        //     .questions;
        // allSpec.data.map(
        //   (e) => (formatTorelance = e.attributes.formatTorelance)
        // );
        try {
          const specData =
            typeof getSpec === "string" ? JSON.parse(getSpec) : getSpec;
          allSpecCount = specData.data.data.attributes.sub_categories.data.map(
            (e) => e.attributes.questions.data[0].attributes.specCount,
          );
          allTorelance = specData.data.data.attributes.sub_categories.data.map(
            (e) => e.attributes.questions.data[0].attributes.torelance1,
          );
          allTorelance2 = specData.data.data.attributes.sub_categories.data.map(
            (e) => e.attributes.questions.data[0].attributes.torelance2,
          );
          // console.log("Check Spec-Count:", allSpecCount);
        } catch (err) {
          console.error("Invalid JSON in getSpec:", getSpec, err);
        }
      }
      // console.log(`Check Spec-Count : ${allSpecCount}`);
      // console.log(`Check torelance1 : ${allTorelance}`);
      // console.log(`Check torelance2 : ${allTorelance2}`);
      // console.log(`Check formatTorelance : ${formatTorelance}`);

      const response = await APIServices.getManyPaper(checkedArray);
      const result = response.data.data;
      let updatedData = updateCplData(result, result);
      console.log(updatedData);
      const dataForExport = exportDataALL(updatedData);

      //Condition from Inspection Item > 8 or not
      if (allTorelance2.length > 8) {
        const firstPartData = dataForExport.dataquestion.slice(0, 8);
        const secondPartData = dataForExport.dataquestion.slice(8);

        await export_cpk2(
          dataForExport,
          firstPartData,
          secondPartData,
          allTorelance,
          allTorelance2,
          formatTorelance,
          allSpecCount,
          2,
        );
        // await export_cpk2(
        //   dataForExport,
        //   secondPartData,
        //   allTorelance,
        //   allTorelance2,
        //   formatTorelance,
        //   allSpecCount,
        //   2
        // );
      } else {
        const firstPartData = dataForExport.dataquestion.slice(0, 8);
        const secondPartData = dataForExport.dataquestion.slice(8) ?? 0;

        await export_cpk2(
          dataForExport,
          firstPartData,
          secondPartData,
          allTorelance,
          allTorelance2,
          formatTorelance,
          allSpecCount,
          1,
        );
      }

      // cplData = [];
    } catch (e) {
      console.error("Error in DownloadCPK:", e);
    }
    setLoading(false);
  };

  // const downloadCpu = async () => {
  //   setLoading(true);
  //   try {
  //     let formatTorelance = "";
  //     let allTorelance = [];
  //     let allTorelance2 = [];
  //     let allSpecCount = [];
  //     const checkedArray = Object.keys(checkedPaperId).map((key) => key);
  //     if (checkedArray.length === 0) {
  //       return;
  //     }
  //     if (partsId) {
  //       const getSpec = await APIServices.getPartByID(partsId);
  //       const allSpec =
  //         getSpec.data.data.attributes.sub_categories.data[0].attributes
  //           .questions;
  //       Array.isArray(
  //         allSpec.data.map((e) => allTorelance.push(e.attributes.torelance1))
  //       );
  //       Array.isArray(
  //         allSpec.data.map((e) => allTorelance2.push(e.attributes.torelance2))
  //       );
  //       Array.isArray(
  //         allSpec.data.map((e) => allSpecCount.push(e.attributes.specCount))
  //       );
  //       allSpec.data.map(
  //         (e) => (formatTorelance = e.attributes.formatTorelance)
  //       );
  //     }
  //     console.log(`Check Spec-Count : ${allSpecCount}`);
  //     console.log(`Check torelance1 : ${allTorelance}`);
  //     console.log(`Check torelance2 : ${allTorelance2}`);
  //     console.log(`Check formatTorelance : ${formatTorelance}`);
  //     const response = await APIServices.getManyPaper(checkedArray);
  //     const result = response.data.data;
  //     console.log(result);

  //     let updatedData = updateCplData(result, result);
  //     console.log(updatedData);
  //     const dataForExport = exportDataALL(updatedData);
  //     console.log(dataForExport);
  //     await export_cpu(
  //       dataForExport,
  //       allTorelance,
  //       allTorelance2,
  //       formatTorelance,
  //       allSpecCount
  //     );
  //     // cplData = [];
  //   } catch (e) {
  //     console.error("Error in DownloadCPL:", e);
  //   }
  //   setLoading(false);
  // };

  // const downloadCpl = async () => {
  //   setLoading(true);
  //   try {
  //     // let allTorelance = [];
  //     let formatTorelance = "";
  //     let allTorelance = [];
  //     let allTorelance2 = [];
  //     let allSpecCount = [];
  //     const checkedArray = Object.keys(checkedPaperId).map((key) => key);
  //     if (checkedArray.length === 0) {
  //       return;
  //     }
  //     if (partsId) {
  //       const getSpec = await APIServices.getPartByID(partsId);

  //       console.log(
  //         "CHECK DATA PART :",
  //         getSpec.data.data.attributes.sub_categories.data[0].attributes
  //           .questions.data[0].attributes
  //       );
  //       const allSpec =
  //         getSpec.data.data.attributes.sub_categories.data[0].attributes
  //           .questions;
  //       Array.isArray(
  //         allSpec.data.map((e) => allTorelance.push(e.attributes.torelance1))
  //       );
  //       Array.isArray(
  //         allSpec.data.map((e) => allTorelance2.push(e.attributes.torelance2))
  //       );
  //       Array.isArray(
  //         allSpec.data.map((e) => allSpecCount.push(e.attributes.specCount))
  //       );
  //       allSpec.data.map(
  //         (e) => (formatTorelance = e.attributes.formatTorelance)
  //       );
  //     }
  //     console.log(`Check Spec-Count : ${allSpecCount}`);
  //     console.log(`Check torelance1 : ${allTorelance}`);
  //     console.log(`Check torelance2 : ${allTorelance2}`);
  //     console.log(`Check formatTorelance : ${formatTorelance}`);

  //     const response = await APIServices.getManyPaper(checkedArray);
  //     const result = response.data.data;
  //     let updatedData = updateCplData(result, result);
  //     // console.log("UPDATED DATA", updatedData);
  //     console.log("Check result from Api ", result);
  //     console.log("CHECK updated data", updatedData);

  //     const dataForExport = exportDataALL(updatedData);
  //     console.log(dataForExport);
  //     await export_cpl(
  //       dataForExport,
  //       allTorelance,
  //       allTorelance2,
  //       formatTorelance,
  //       allSpecCount
  //     );
  //     // cplData = [];
  //   } catch (e) {
  //     console.error("Error in DownloadCPL:", e);
  //   }
  //   setLoading(false);
  // };

  return (
    <div className="">
      <SimpleBackdrop open={loading} setOpen={setLoading} />
      <TableContainer component={Paper}>
        <div className={`p-4`}>
          <div className={`h-full flex items-end pb-1 text-xl`}>
            ประวัติการตรวจสอบย้อนหลัง
            {papers !== undefined && (
              <span className="ml-2 text-sm text-gray-500 font-normal">
                (ทั้งหมด {papers.length} รายการ)
              </span>
            )}
          </div>
          <div className={`mt-2 flex justify-between items-end`}>
            <div className={`flex items-end gap-4`}>
              <DateTime
                value={startDate.value}
                // autoFocus={startDate.error}
                label={`Start date`}
                onChange={handleOnChangeStartDate}
              />
              <DateTime
                value={endDate.value}
                // autoFocus={startDate.error}
                label={`End date`}
                onChange={handleOnChangeEndDate}
              />
              <Button
                className="bg-orangeCustom"
                variant="contained"
                size={`small`}
                onClick={() => {
                  submitSearch();
                }}
              >
                <Search />
              </Button>
            </div>
            <div className={``}>
              {/* <Button
                className="bg-orangeCustom"
                variant="contained"
                endIcon={<FileDownload />}
                onClick={downloadCpk}
                disabled={Object.keys(checkedPaperId).length === 0}
                style={{ marginRight: 20 }}
              >
                CP & CPK
              </Button> */}
              {/* <Button
                className="bg-orangeCustom"
                variant="contained"
                endIcon={<FileDownload />}
                onClick={downloadCpk_2}
                disabled={Object.keys(checkedPaperId).length === 0}
                style={{ marginRight: 20 }}
              >
                CP & CPK 2
              </Button> */}
              <Button
                className="bg-orangeCustom"
                variant="contained"
                endIcon={<FileDownload />}
                onClick={() => downloadCpk_2("plusMinus")}
                disabled={Object.keys(checkedPaperId).length === 0}
                style={{ marginRight: 20 }}
              >
                CP & CPK +/-
              </Button>
              <Button
                className="bg-orangeCustom"
                variant="contained"
                endIcon={<FileDownload />}
                onClick={() => downloadCpk_2("plusPlus")}
                disabled={Object.keys(checkedPaperId).length === 0}
                style={{ marginRight: 20 }}
              >
                CP & CPK +/+
              </Button>
              <Button
                className="bg-orangeCustom"
                variant="contained"
                endIcon={<FileDownload />}
                onClick={() => downloadCpk_2("minusMinus")}
                disabled={Object.keys(checkedPaperId).length === 0}
                style={{ marginRight: 20 }}
              >
                CP & CPK -/-
              </Button>
              {/* <Button
                className="bg-orangeCustom"
                variant="contained"
                endIcon={<FileDownload />}
                onClick={downloadCpl}
                disabled={Object.keys(checkedPaperId).length === 0}
                style={{ marginRight: 20 }}
              >
                CPL
              </Button> */}
              {/* <Button
                className="bg-orangeCustom"
                variant="contained"
                endIcon={<FileDownload />}
                onClick={downloadCpu}
                disabled={Object.keys(checkedPaperId).length === 0}
                style={{ marginRight: 20 }}
              >
                CPU
              </Button> */}
              {/* <Button
                className="bg-gray-500"
                variant="contained"
                endIcon={<FileDownload />}
                onClick={downloadReport}
                disabled={Object.keys(checkedPaperId).length === 0}
              >
                Inspection Sheet
              </Button> */}
            </div>
          </div>
        </div>
        {loading && <LinearProgress color="primary" />}
        <Table sx={{ minWidth: 550 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="center">
                <Checkbox
                  onChange={clearAllCheckedPaperId}
                  checked={
                    papers.length > 0 &&
                    Object.keys(checkedPaperId).length === papers.length
                  }
                  indeterminate={
                    Object.keys(checkedPaperId).length > 0 &&
                    Object.keys(checkedPaperId).length < papers.length
                  }
                />
              </TableCell>
              {role === "inspector" && (
                <TableCell align="center">
                  <TableSortLabel
                    active={orderBy === "id"}
                    direction={orderBy === "id" ? order : "asc"}
                    onClick={() => handleRequestSort("id")}
                  >
                    ครั้งที่
                  </TableSortLabel>
                </TableCell>
              )}
              <TableCell align="center">
                <TableSortLabel
                  active={orderBy === "create_datetime"}
                  direction={orderBy === "create_datetime" ? order : "asc"}
                  onClick={() => handleRequestSort("create_datetime")}
                >
                  วันและเวลา
                </TableSortLabel>
              </TableCell>
              <TableCell align="center">
                <TableSortLabel
                  active={orderBy === "status"}
                  direction={orderBy === "status" ? order : "asc"}
                  onClick={() => handleRequestSort("status")}
                >
                  Status
                </TableSortLabel>
              </TableCell>
              <TableCell align="center">
                <TableSortLabel
                  active={orderBy === "machineNumber"}
                  direction={orderBy === "machineNumber" ? order : "asc"}
                  onClick={() => handleRequestSort("machineNumber")}
                >
                  M/C
                </TableSortLabel>
              </TableCell>
              {(role === "checker" ||
                role === "approver" ||
                role === "super_admin" ||
                role === "admin") && (
                <TableCell align="center">Inspector</TableCell>
              )}
              <TableCell align="center">Checker</TableCell>
              <TableCell align="center">Approver</TableCell>
              <TableCell align="center">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedPapers.length === 0 && !loading && (
              <TableRow>
                <TableCell
                  colSpan={role === "inspector" ? 7 : 8}
                  align="center"
                  sx={{ py: 4, color: "text.secondary" }}
                >
                  ไม่พบข้อมูลประวัติในช่วงเวลาที่เลือก
                </TableCell>
              </TableRow>
            )}
            {sortedPapers.map((row, index) => {
              return (
                <TableRow
                  hover
                  key={`tableRow${row.id}`}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  // onClick={() => gotoViewPaper(row.id, index)}
                  className={`cursor-pointer`}
                >
                  <TableCell align="center">
                    <Checkbox
                      onChange={(e, checked) =>
                        handleCheckedPaper(checked, row.id)
                      }
                      checked={checkedPaperId[`${row.id}`] ? true : false}
                    />
                  </TableCell>
                  {/* <TableCell align="center">{row.id}</TableCell> */}
                  {role === "inspector" && (
                    <TableCell component="th" scope="row" align="center">
                      {index + 1}
                    </TableCell>
                  )}
                  <TableCell component="th" scope="row" align="center">
                    {row.attributes.create_datetime &&
                      dayjs(row.attributes.create_datetime).format(
                        "DD-MM-YYYY HH:mm",
                      )}
                  </TableCell>
                  {/* <TableCell align="center">{row.attributes.shift}</TableCell> */}
                  <TableCell align="center">
                    <div className={`flex justify-center`}>
                      {parseStatus(row.attributes.status)}
                    </div>
                  </TableCell>
                  <TableCell align="center">
                    {row.attributes?.machineNumber || "-"}
                  </TableCell>
                  {(role === "checker" ||
                    role === "approver" ||
                    role === "super_admin" ||
                    role === "admin") && (
                    <TableCell align="center">
                      {parseFullNameFromUser(
                        row.attributes.inspector_id?.data?.attributes,
                      )}
                    </TableCell>
                  )}
                  {/* {role === "approver" && ( */}
                  <>
                    <TableCell align="center">
                      {parseFullNameFromUser(
                        row.attributes.checker_id?.data?.attributes,
                      )}
                    </TableCell>
                    <TableCell align="center">
                      {parseFullNameFromUser(
                        row.attributes.approver_id?.data?.attributes,
                      )}
                    </TableCell>
                    <TableCell align="center">
                      <Action row={row} index={index} />
                    </TableCell>
                  </>
                  {/* )} */}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <DeletePaperModal
        open={openDelete.open}
        setOpen={setOpenDelete}
        action={deletePaper}
        confirmText={"ใช่"}
        cancelText={"ยกเลิก"}
        header={"ยืนยันการลบข้อมูล"}
        message={
          <span>
            คุณต้องการ
            <span>{openDelete.message}</span>
          </span>
        }
        data={data}
      />
    </div>
  );
};

export default CustomDateHistory;
